export enum CargoStatus {
  Open = 'Open',
  Poss = 'Poss',
  OnSubs = 'On Subs',
  Fixed = 'Fixed',
  Withdrawn = 'Withdrawn',
  Failed = 'Failed',
  OnHold = 'On Hold',
}

export const quickEditStatusOptions = [
  CargoStatus.OnSubs,
  CargoStatus.Fixed,
  CargoStatus.Failed,
  CargoStatus.Withdrawn,
  CargoStatus.OnHold,
]

export const statusOptions = Object.values(CargoStatus)

export const quantityUnitOptions = ['MT', 'CBM', 'BBL']
export const getRateOptions = ({
  withIndividualOption,
}: {
  withIndividualOption?: boolean
} = {}) => [
  'WS',
  'LS',
  'USD/MT',
  ...(withIndividualOption ? ['Individual'] : []),
]
export const periodOptions = ['Months', 'Days']
